import React, { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { Modal } from '../ui'
import NotificationPreferencesEditor from './NotificationPreferencesEditor'
import type { NotificationPreferencesData } from '../../types/notifications'
import type { NotificationPreferenceUpdate } from '../../types/notifications'
import type { WatchlistEntityType } from '../../services/watchlist'

interface WatchlistItemNotificationModalProps {
  open: boolean
  onClose: () => void
  displayName: string
  entityType: WatchlistEntityType
  preferences: NotificationPreferencesData
  onSave: (updates: NotificationPreferenceUpdate[]) => Promise<NotificationPreferencesData>
  /** Show link to global notification settings (inbox flow). */
  showGlobalLink?: boolean
}

const WatchlistItemNotificationModal: React.FC<WatchlistItemNotificationModalProps> = ({
  open,
  onClose,
  displayName,
  entityType,
  preferences,
  onSave,
  showGlobalLink = false,
}) => {
  const [localPrefs, setLocalPrefs] = useState(preferences)

  useEffect(() => {
    if (open) setLocalPrefs(preferences)
  }, [open, preferences])

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={displayName}
      size="md"
    >
      <div className="max-h-[min(60vh,24rem)] overflow-y-auto -mx-1 px-1">
        <NotificationPreferencesEditor
          types={localPrefs.types}
          scope="item"
          entityType={entityType}
          onSave={async (updates) => {
            const next = await onSave(updates)
            setLocalPrefs(next)
            return next
          }}
        />
      </div>
      {showGlobalLink ? (
        <p className="mt-3 pt-2 border-t border-rule text-xs">
          <Link
            to="/account/notifikationer/indstillinger"
            onClick={onClose}
            className="text-ink underline decoration-ink-300 underline-offset-[3px] hover:decoration-ink"
          >
            Globale notifikationsindstillinger
          </Link>
        </p>
      ) : null}
    </Modal>
  )
}

export default WatchlistItemNotificationModal
